import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';
import AdditionalCostsModal from '../modals/AdditionalCostsModal';

function AdditionalCostsContainer({
  applicationId,
  additionalCostList, removeData,
  getList,
  type,
  isLoading,
}) {
  const setModal = useContext(ModalContext);

  const handleAddAdditionItems = () => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <AdditionalCostsModal applicationId={applicationId} type="NEW" />,
      title: 'Add Additional Cost',
      modalSize: 'modal-md',
    });
  };

  const handleEditAdditionItems = detail => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AdditionalCostsModal
          dataInfo={detail.attributes}
          applicationId={applicationId}
          id={detail.id}
          type="EDIT"
        />
      ),
      title: 'Update Additional Cost',
      modalSize: 'modal-md',
    });
  };

  const handleRemoveAdditionItems = detail => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure you want to remove this additional cost?',
      () => {
        removeData(applicationId, detail.id, () => {
          getList(applicationId);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
    );
  };

  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getList(applicationId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(applicationId)) return;
    getList(applicationId);
  }, [applicationId]);

  return (
    <>
      <div className="card-content-listing">
        <div className="card p-0 mr-2">
          {isLoading ? (
            <div className="loading">
              <div className="spinner text-center">
                <span className="fas fa-1x fa-spin fa-spinner" />
              </div>
            </div>
          ) : (
            <>
              <div className="row mb-3 d-flex align-items-center">
                <div className="col py-3">
                  <h3 className="m-0 title-color">Additional Cost</h3>
                </div>
                {type !== 'history' && (
                  <div className="col py-0 m-0 d-flex">
                    <button
                      type="button"
                      onClick={handleAddAdditionItems()}
                      className="btn btn-primary cms-bg-color-primary cms-outline-primary btn-round font-weight-bold px-4 ml-auto"
                    >
                      <i className="fas fa-plus" /> Add Additional Cost
                    </button>

                  </div>
                )}
              </div>
              <div className="row my-3 mx-2">
                <table className="css-table table table-borderless table-sm table-striped table-hover">
                  <thead className="table-header">
                    <tr>
                      <td className="font-weight-bold">Name</td>
                      <td className="font-weight-bold">Description</td>
                      <td className="font-weight-bold">Cost</td>
                      <td />
                    </tr>
                  </thead>
                  <tbody>
                    {_.isEmpty(additionalCostList) ? (
                      <tr className="w-100">
                        <td colSpan="5" className="text-center border-top p-4 text-muted">
                          This Section is Empty
                        </td>
                      </tr>
                    ) : (
                      additionalCostList.map(item => (
                        <tr key={item.id}>
                          <td className="history-color">{_.get(item, 'attributes.name')}</td>
                          <td className="history-color">{_.get(item, 'attributes.description') || ''}</td>
                          <td className="history-color">{_.get(item, 'attributes.cost') || ''}</td>
                          {type !== 'history' && (
                            <td className="pr-4">
                              <div className="d-flex">
                                <button type="button" className="btn-blank ml-auto" onClick={handleEditAdditionItems(item)}>
                                  <i className="far fa-edit icon-edit" />
                                </button>
                                <button type="button" className="btn-blank" onClick={handleRemoveAdditionItems(item)}>
                                  <i className="far fa-trash-alt icon-delete" />
                                </button>
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

AdditionalCostsContainer.propTypes = {
  applicationId: PropTypes.string,
  getList: PropTypes.instanceOf(Function).isRequired,
  additionalCostList: PropTypes.instanceOf(Array).isRequired,
  removeData: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
};

AdditionalCostsContainer.defaultProps = {
  applicationId: '',
  type: '',
};

const mapStateToProps = ({ api }) => ({
  additionalCostList: _.get(api, `${c.GET_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_LIST) > -1,
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);


export default enhance(AdditionalCostsContainer);
